<template>
  <div class="p-3 p-lg-4 border-bottom">
    <div class="d-flex align-items-center">
      <div class="d-block d-lg-none mr-2">
        <a
          href="#"
          class="user-chat-remove text-muted font-size-16 p-2"
          @click.prevent="closeUserChat"
        >
          <i class="ri-arrow-left-s-line" />
        </a>
      </div>
      <status-rooms-components
        :room="room"
        class="d-flex mr-3"
      />
      <add-contact-btn :room="room">
        <template v-slot="{onClick}">
          <h5
            class="font-size-16 mb-0 text-reset text-truncate"
            style="cursor:pointer;"
            @click="onClick"
          >
            {{ contactName }}
          </h5>
        </template>
      </add-contact-btn>
      <img
        v-if="channelName"
        :src="require(`@/assets/images/channel/${channelName}.png`)"
        class="ml-2 rounded-circle"
        style="width: 1rem; height: 1rem;"
        :alt="channelName"
        :title="channelName"
      >
      <reassign-with
        class="ml-2 font-size-16"
        :room="room"
        :show-avatar="true"
      >
        <span slot="before-str">
          {{ $t('room.header.reassign.with.title') }}
        </span>
      </reassign-with>
      <ul class="flex-fill d-flex justify-content-end list-inline user-chat-nav mb-0 ml-2">
        <li class="list-inline-item">
          <button
            v-b-tooltip.hover
            :title="$t(`room.header.search.title`)"
            type="button"
            class="btn nav-btn"
            @click="showSearch = !showSearch"
          >
            <i class="ri-search-line" />
          </button>
        </li>
        <li class="list-inline-item d-none d-lg-inline-block">
          <resolved-box :room="room">
            <template v-slot="{isResolved, disabled, onClick}">
              <button
                v-b-tooltip.hover
                :title="$t(`room.header.resolved.${isResolved ? 'unresolved' : 'resolved'}`)"
                type="button"
                class="btn nav-btn"
                :disabled="disabled"
                @click="onClick"
              >
                <i
                  class="text-muted"
                  :class="[isResolved ? 'ri-forbid-2-line' : 'ri-check-line']"
                />
              </button>
            </template>
          </resolved-box>
        </li>
        <li class="list-inline-item d-none d-lg-inline-block">
          <favorite-box :entity-id="room && room.id">
            <template v-slot="{isFavorite, disabled, onClick}">
              <button
                v-b-tooltip.hover
                :title="$t(`room.header.favorite.${isFavorite ? 'unfavorite' : 'favorite'}`)"
                type="button"
                class="btn nav-btn"
                :disabled="disabled"
                @click="onClick"
              >
                <i :class="[isFavorite ? 'ri-star-fill' : 'ri-star-line']" />
              </button>
            </template>
          </favorite-box>
        </li>
        <li class="list-inline-item d-none d-lg-inline-block">
          <add-contact-btn :room="room">
            <template v-slot="{isExist, disabled, onClick}">
              <button
                v-b-tooltip.hover
                :title="$t(`room.header.add_contact.${isExist ? 'edit' : 'add'}`)"
                type="button"
                class="btn nav-btn"
                :disabled="disabled"
                @click="onClick"
              >
                <i :class="[isExist ? 'ri-user-line' : 'ri-user-add-line']" />
              </button>
            </template>
          </add-contact-btn>
        </li>
        <li class="list-inline-item">
          <b-dropdown
            toggle-class="nav-btn"
            variant="white"
            right
          >
            <template v-slot:button-content>
              <i class="ri-more-fill" />
            </template>
            <reassign-box :room="room">
              <template v-slot="{onClick, disabled}">
                <b-dropdown-item
                  :disabled="disabled"
                  link-class="d-flex justify-content-between align-items-center"
                  @click="onClick"
                >
                  <span>{{ $t('room.header.reassign.reassign') }}</span>
                  <i class="ri-user-line ml-2 text-muted" />
                </b-dropdown-item>
              </template>
            </reassign-box>
            <favorite-box :entity-id="room && room.id">
              <template v-slot="{isFavorite, disabled, onClick }">
                <b-dropdown-item
                  :disabled="disabled"
                  class="d-block d-lg-none"
                  @click="onClick"
                >
                  <span class="d-flex justify-content-between align-items-center">
                    {{ $t(`room.header.favorite.${isFavorite ? 'unfavorite' : 'favorite'}`) }}
                    <i
                      class=" ml-2 text-muted"
                      :class="[isFavorite ? 'ri-star-fill' : 'ri-star-line']"
                    />
                  </span>
                </b-dropdown-item>
              </template>
            </favorite-box>
            <add-contact-btn :room="room">
              <template v-slot="{isExist, disabled, onClick}">
                <b-dropdown-item
                  :disabled="disabled"
                  hide-class="d-block d-lg-none"
                  link-class="d-flex justify-content-between align-items-center"
                  @click="onClick"
                >
                  {{ $t('room.header.add_contact.' + (isExist ? 'edit' : 'add')) }}
                  <i
                    class="ml-2 text-muted"
                    :class="[isExist ? 'ri-user-line' : 'ri-user-add-line']"
                  />
                </b-dropdown-item>
              </template>
            </add-contact-btn>
            <export-box :room="room">
              <template v-slot="{onClick, disabled}">
                <b-dropdown-item
                  :disabled="disabled"
                  link-class="d-flex justify-content-between align-items-center"
                  @click="onClick"
                >
                  {{ $t('room.header.export.title') }}
                  <i class="ri-download-line ml-2 text-muted" />
                </b-dropdown-item>
              </template>
            </export-box>
          </b-dropdown>
        </li>
      </ul>
    </div>
    <search-box :room-id="room && room.id" />
  </div>
</template>

<script>
import contactName from "../../utils/contactName";
import ReassignBox from "./Header/ReassignHeaderRoomComponents";
import ResolvedBox from "./Header/ResolvedHeaderRoomComponents";
import FavoriteBox from "./Header/FavoriteHeaderRoomComponents";
import AddContactBtn from "./Header/AddContact/BtnAddContactHeaderRoomComponents";
import ExportBox from "./Header/ExportHeaderRoomComponents";
import ReassignWith from "./Header/WithHeaderRoomComponents";
import SearchBox from "./Header/Search/SearchHeaderRoomComponents";
import StatusRoomsComponents from "../Rooms/List/Helpers/StatusRoomsComponents";

export default {
  name: 'RoomHeader',
  components: {
    StatusRoomsComponents,
    ReassignBox,
    ResolvedBox,
    FavoriteBox,
    AddContactBtn,
    ExportBox,
    ReassignWith,
    SearchBox,
  },
  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    showSearch: {
      get() {
        return this.$store.state.roomSearch.show;
      },
      set(is) {
        return this.$store.commit('roomSearch/SET_SHOW', is);
      },
    },
    channelName() {
      return this.room?.channel_name?.toLowerCase()
    },
    contactName() {
      return this.room?.id && contactName(this.room)
    },
  },
  methods: {
    closeUserChat() {
      this.$store.commit('rooms/SET_HIDE_ROOM')
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
